import React from 'react';
import ServicePage from './ServicePage';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import DatabaseImage from "../assets/database.webp";
import styled from 'styled-components';

const DatabaseCard = styled.div`
  flex: ${props => props.width || '0 0 27%'};
  margin-bottom: 30px;
  padding: ${props => props.padding || '25px'};
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  text-align: ${props => props.align || 'center'};
  
  @media (max-width: 1140px) {
    flex: 0 0 90%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 85%;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: space-around;
  }
  
  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const DatabaseManagementPage = () => {
  const features = [
    'Database design and architecture optimization',
    'Performance tuning and query optimization',
    'Data migration and integration services',
    'High availability and disaster recovery solutions',
    'Security implementation and access control',
    'Proactive monitoring and maintenance'
  ];

  const additionalContent = (
    <div>
      <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333', textAlign: 'center' }}>
        Database Solutions We Support
      </h3>
      <CardContainer>
        <DatabaseCard>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>MySQL</h4>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
            Complete management of MySQL databases, including optimization, replication, and clustering.
          </p>
        </DatabaseCard>
        <DatabaseCard>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>PostgreSQL</h4>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
            Expert PostgreSQL database administration, performance tuning, and high-availability setup.
          </p>
        </DatabaseCard>
        <DatabaseCard>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Microsoft SQL</h4>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
            Comprehensive SQL Server management, including performance optimization and AlwaysOn availability.
          </p>
        </DatabaseCard>
        <DatabaseCard>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>MongoDB</h4>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
            NoSQL database management, including sharding, replication, and performance optimization.
          </p>
        </DatabaseCard>
        <DatabaseCard width="0 0 60.5%" padding="30px" align="left">
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Database Health Monitoring</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Our proactive monitoring system continuously tracks database performance metrics, query execution times, resource utilization, and potential bottlenecks. We identify and resolve issues before they impact your business operations.
          </p>
        </DatabaseCard>
        <DatabaseCard width="0 0 95%" padding="30px" align="left">
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Data Security & Compliance</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We implement robust security measures to protect your valuable data, including encryption, access control, and audit logging. Our solutions help ensure compliance with regulations such as GDPR, HIPAA, and PCI DSS.
          </p>
        </DatabaseCard>
      </CardContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faDatabase}
      title="Database Management"
      subtitle="Expert database administration and optimization services to ensure your data is secure, accessible, and performing at its best."
      description={["At Zenitech Solutions, our Database Management service offers end-to-end solutions for designing, deploying, and maintaining robust database infrastructures tailored to your business needs. Whether you're working with SQL, NoSQL, or hybrid environments, we ensure your data systems deliver peak performance, ironclad security, and rock-solid reliability.",

        "Our team of experienced database professionals handles everything from schema design and routine maintenance to advanced performance tuning, data recovery, and real-time troubleshooting. We take a proactive approach to prevent downtime, eliminate bottlenecks, and ensure your critical data assets are always available, accurate, and secure.",
        
        "With Zenitech Solutions managing your databases, you gain the confidence of knowing your backend is as strong and scalable as the rest of your business. Let us help you turn your data into a competitive advantage."]}
      features={features}
      imagePath={DatabaseImage}
      additionalContent={additionalContent}
      featuresDesciption="We deliver end-to-end database management solutions tailored to your unique business needs. Our expert team ensures your data infrastructure is optimized, secure, and reliable — with precision, care, and a commitment to top-quality service."
      metaTitle="Database Management Services"
      metaDescription="Our Database Management services provide comprehensive solutions for designing, deploying, and maintaining robust database infrastructures. From schema design and routine maintenance to advanced performance tuning, data recovery, and real-time troubleshooting, we ensure your data systems deliver peak performance, ironclad security, and rock-solid reliability."
    />
  );
};

export default DatabaseManagementPage;